export const vueTableDefaults = {
  'All_Members_Accounts': {
    sortOrder: {
      field: 'church_last_login_time',
      sortField: 'church_last_login_time',
      direction: 'desc',
    },
  },
  'Login_Activities': {
    sortOrder: {
      field: 'login_timestamp',
      sortField: 'login_timestamp',
      direction: 'desc',
    },
  },
  'All_Members_Profiles': {
    sortOrder: {
      field: 'membership_id',
      sortField: 'membership_id',
      direction: 'desc',
    },
  },
  'All_Visitors': {
    sortOrder: {
      field: 'created_at',
      sortField: 'created_at',
      direction: 'desc',
    },
  },
  'All_Zones': {
    sortOrder: {
      field: 'name',
      sortField: 'name',
      direction: 'asc',
    },
  },
  'All_Services': {
    sortOrder: {
      sortField: 'service_name',
      direction: 'desc',
    },
  },
  'All_Ministries': {
    sortOrder: {
      field: 'name',
      sortField: 'name',
      direction: 'asc',
    },
  },
  'All_Positions': {
    sortOrder: {
      field: 'name',
      sortField: 'name',
      direction: 'asc',
    },
  },
  'All_Service_Types': {
    sortOrder: {
      field: 'weekday_id',
      sortField: 'weekday_id',
      direction: 'asc',
    },
  },
  'All_Giving_Types': {
    sortOrder: {
      field: 'sort_order',
      sortField: 'sort_order',
      direction: 'asc',
    },
  },
  'All_Roster_Templates': {
    sortOrder: {
      field: 'name',
      sortField: 'name',
      direction: 'asc',
    },
  },
  'All_SMS_Templates': {
    sortOrder: {
      field: 'name',
      sortField: 'name',
      direction: 'asc',
    },
  },
  'All_Sms_Transactions': {
    sortOrder: {
      field: 'transacted_at',
      sortField: 'transacted_at',
      direction: 'desc',
    },
  },
  'All_Downloadable_Files': {
    sortOrder: {
      field: 'id',
      sortField: 'id',
      direction: 'asc',
    },
  },
  'Group_Members': {
    sortOrder: {
      field: 'id',
      sortField: 'id',
      direction: 'asc',
    },
  },
  'Ministry_Members': {
    sortOrder: {
      field: 'id',
      sortField: 'id',
      direction: 'asc',
    },
  },
  'Migration_Summary': {
    sortOrder: {
      field: 'ended_at',
      sortField: 'ended_at',
      direction: 'desc',
    },
  },
  'All_Churches': {
    sortOrder: {
      field: 'created_at',
      sortField: 'created_at',
      direction: 'desc',
    },
  },
  'All_Permissions': {
    sortOrder: {
      field: 'id',
      sortField: 'id',
      direction: 'asc',
    },
  },
  'Permission_Roles': {
    sortOrder: {
      field: 'name',
      sortField: 'name',
      direction: 'asc',
    },
  },
  'PermissionUsers': {
    sortOrder: {
      field: 'full_name',
      sortField: 'full_name',
      direction: 'desc',
    },
  },
  'All_Members_For_Position*': {
    sortOrder: {
      field: 'full_name',
      sortField: 'full_name',
      direction: 'desc',
    },
  },
  'Service_Absentees_Report*': {
    sortOrder: {
      field: 'membership_id',
      sortField: 'membership_id',
      direction: 'desc',
    },
  },
  'Membership_Placement_Report*': {
    sortOrder: {
      field: 'membership_id',
      sortField: 'membership_id',
      direction: 'desc',
    },
  },
  'All_Roles': {
    sortOrder: {
      field: 'name',
      sortField: 'name',
      direction: 'asc',
    },
  },
  'Role_Permissions': {
    sortOrder: {
      field: 'name',
      sortField: 'name',
      direction: 'asc',
    },
  },
  'Role_Users': {
    sortOrder: {
      field: 'full_name',
      sortField: 'full_name',
      direction: 'asc',
    },
  },
  'Service_Absentees': {
    sortOrder: {
      field: 'membership_id',
      sortField: 'membership_id',
      direction: 'desc',
    },
  },
  'Service_Attendees': {
    sortOrder: {
      field: 'membership_id',
      sortField: 'membership_id',
      direction: 'desc',
    },
  },
  'All_Zone_Members': {
    sortOrder: {
      field: 'membership_id',
      sortField: 'membership_id',
      direction: 'desc',
    },
  },
  'All_Service_Visitors': {
    sortOrder: {
      field: 'full_name',
      sortField: 'full_name',
      direction: 'asc',
    },
  },
  'All_Service_Activities': {
    sortOrder: {
      field: 'name',
      sortField: 'name',
      direction: 'asc',
    },
    paginationData: {
      perPage: 20,
    },
  },
  'All_Service_Activities_Templates': {
    sortOrder: {
      field: 'updated_at',
      sortField: 'updated_at',
      direction: 'desc',
    },
  },
  'DenominationRecords': {
    sortOrder: {
      field: 'id',
      sortField: 'id',
      direction: 'asc',
    },
  },
  'ServiceVisitors': {
    sortOrder: {
      field: 'full_name',
      sortField: 'full_name',
      direction: 'asc',
    },
  },
  'All_Rosters': {
    sortOrder: {
      field: 'roster_name',
      sortField: 'roster_name',
      direction: 'asc',
    },
  },
  'NonGlobalUsers': {
    sortOrder: {
      field: 'email',
      sortField: 'email',
      direction: 'asc',
    },
  },
  'All_Membership_Manners': {
    sortOrder: {
      field: 'name',
      sortField: 'name',
      direction: 'asc',
    },
  },
  'MembershipFollowUps': {
    sortOrder: {
      field: 'updated_at',
      sortField: 'updated_at',
      direction: 'desc',
    },
  },
  'DocsProductCategories': {
    sortOrder: {
      field: 'updated_at',
      sortField: 'updated_at',
      direction: 'desc',
    },
  },
  'DocsTopicsTable': {
    sortOrder: {
      field: 'updated_at',
      sortField: 'updated_at',
      direction: 'desc',
    },
  },
  'DocsArticlesTable': {
    sortOrder: {
      field: 'updated_at',
      sortField: 'updated_at',
      direction: 'desc',
    },
  },
  'DocsCategoryLocalisations': {
    sortOrder: {
      field: 'updated_at',
      sortField: 'updated_at',
      direction: 'desc',
    },
  },
  'Global_Users': {
    sortOrder: {
      field: 'full_name',
      sortField: 'full_name',
      direction: 'asc',
    },
  },
};
